import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import AppShell from "../components/AppShell";
import { toast, Toaster } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    mobile_number: "",
    role: "counter",
    password: "",
  });

  const load = async () => {
    try {
      const { data } = await api.get("/users");
      setUsers(data);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    try {
      await api.post("/users", form);
      toast.success("User created");
      setForm({
        full_name: "",
        email: "",
        mobile_number: "",
        role: "counter",
        password: "",
      });
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <AppShell>
      <Toaster position="top-right" richColors />

      <div className="p-6 space-y-4">

        <h1 className="text-2xl font-bold">Users</h1>

        {/* CREATE FORM */}
        <div className="border p-4 grid grid-cols-5 gap-2">
          <input placeholder="Full name"
            value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })}
          />

          <input placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />

          <input placeholder="Mobile"
            value={form.mobile_number}
            onChange={(e) => setForm({ ...form, mobile_number: e.target.value })}
          />

          <select
            value={form.role}
            onChange={(e) => setForm({ ...form, role: e.target.value })}
          >
            <option value="admin">Admin</option>
            <option value="counter">Counter</option>
            <option value="head_counter">Head Counter</option>
            <option value="alley_head">Alley Head</option>
            <option value="wh_alley">WH-Alley (view only)</option>
          </select>

          <input type="password" placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />

          <button onClick={create} className="bg-indigo-900 text-white px-3 py-2">
            Create
          </button>
        </div>

        {/* USERS TABLE */}
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.full_name}</td>
                <td>{u.email}</td>
                <td>{u.role}</td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </AppShell>
  );
}
